import * as React from 'react';

import CloseIcon from 'CloseIcon';
import ImageIcon from 'ImageIcon';

const DEFAULT_WIDTH = 300;
const BORDER = 1;
const MARGIN = 10;

export default class ZoomView extends React.Component {
  render() {
    let c = this.props.controller;
    let m = this.props.model;

    let children = [
      <div key="children-div-1" className="zoom-image-close-container">
        <CloseIcon className="zoom-image-close-x" color="#999999" />
      </div>,
    ];

    let image = m.image;
    let containerStyle = {};
    let imageStyle = {};

    if (m.imageLoaded) {
      if (
        image.width + BORDER + MARGIN > window.innerWidth ||
        image.height + BORDER + MARGIN > window.innerHeight
      ) {
        let scaledImageWidth = image.width;
        let scaledImageHeight = image.height;

        if (image.width > image.height) {
          scaledImageWidth = window.innerWidth - BORDER * 2 - MARGIN * 2;
          scaledImageHeight = (scaledImageWidth / image.width) * image.height;
          containerStyle.width = window.innerWidth - MARGIN * 2;
        } else {
          scaledImageHeight = window.innerHeight - BORDER * 2 - MARGIN * 2;
          scaledImageWidth = (scaledImageHeight / image.height) * image.width;
          containerStyle.width = scaledImageWidth + BORDER * 2;
          containerStyle.height = window.innerHeight - MARGIN * 2;
        }

        imageStyle.height = scaledImageHeight;
        imageStyle.width = scaledImageWidth;
      } else {
        containerStyle.width = image.width + BORDER * 2;
        containerStyle.height = image.height + BORDER * 2;
        imageStyle.width = image.width;
        imageStyle.height = image.height;
      }

      children.push(
        <img
          key="children-img-1"
          className="zoom-image"
          src={image.src}
          style={imageStyle}
        />
      );
    } else {
      children.push(
        <div key="children-div-2" className="zoom-image-placeholder-container">
          <ImageIcon className="zoom-image-placeholder" />
        </div>
      );

      containerStyle.width = `${DEFAULT_WIDTH + BORDER + BORDER}px`;
    }

    return (
      <div
        id="zoom-view-background"
        className="modal open"
        onClick={c.closeClicked}
      >
        <div id="zoom-view-box" className="modal-dialog" style={containerStyle}>
          {children}
        </div>
      </div>
    );
  }
}
